import React, { Component } from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import Home from 'react-icons/lib/fa/home';

import Clayborn1 from './../assets/img/projects/clayborn-1.jpg';
import Clayborn2 from './../assets/img/projects/clayborn-2.jpg';
import Clayborn3 from './../assets/img/projects/clayborn-3.jpg';

let simpleParallax;

class ClaybornTemple extends Component {
  componentDidMount() {
    const hamburger = document.querySelector('.nav-hamburger');
    hamburger.style.display = 'none';

    simpleParallax = require('simple-parallax-js');
    const claybornImages = document.querySelectorAll('.clayborn-img');
    new simpleParallax(claybornImages, { scale: 1.1 });
  }

  componentWillUnmount() {
    const hamburger = document.querySelector('.nav-hamburger');
    hamburger.style.display = 'block';
  }

  render() {
    return (
      <div className="project-page">
        <Helmet
            title="Clayborn Temple | Maslow Development Inc."
            meta={[
              { name: 'description', content: 'We co-design & develop real estate and community ecosystems.' },
              { name: 'keywords', content: 'maslow, maslow development, maslow development inc, real estate, community development, community developer, community planner, real estate development, real estate developer, real estate design, real estate designer' }
            ]}
        />

        <Link to='/#highlighted-projects' className='project-page-link-home'>
            ←<Home className='link-home-icon' />
        </Link>

        <h6 className='project-page-label'>Highlighted Project</h6>
        <h1 className='project-page-title'>Clayborn Temple</h1>
        <h5 className='project-page-blurb'>Honoring the Clayborn Temple Civil Rights Treasure</h5>

        <section className='project-page-hero'>
            <img src={Clayborn3} className='project-page-hero-image clayborn-img' alt='Clayborn Temple' />

            <div className='project-page-details'>
                <p className='project-page-detail'>
                    <strong>Challenge</strong>
                    How might we benefit the descendants of the Memphis sanitation workers who staged a strike in 1968 as well as the descendants of 38126?
                </p>
                <p className='project-page-detail'>
                    <strong>Solution</strong>
                    A mixed-use community and cultural hub to promote human formation along with self and community actualization.
                </p>
                <p className='project-page-detail'>
                    <strong>Team</strong>
                    Maslow Development Inc. & Clayborn Reborn
                </p>
            </div>
        </section>

        <img src={Clayborn2} className='project-page-full-image clayborn-img' alt='Clayborn Temple' />

        <h3 className='project-page-quote'>
            The Clayborn Temple campus will be a living commitment to creating a culture that gives rise to innovation, sustainability, human dignity, and access to the beloved community for all Memphians, for generations to come.
            <span>— Anasa Troutman, Executive Director, Clayborn Reborn</span>
        </h3>

        <img src={Clayborn1} className='project-page-full-image clayborn-img' alt='Clayborn Temple' />
      </div>
    );
  }
}

export default ClaybornTemple;



// WEBPACK FOOTER //
// ./src/pages/clayborn-temple.js